
import axios from "axios";

//Importar los helpers.
import { Global } from "../../config/global";


//getChats: Función para traer todos los chats en la bandeja de mensajes.
export const getChatsFinish = async ({ filter, idLastChatPosition, chatEndedSearched }) => { //Función para traer los chats.
    try {
        let responseData = null;
        let idEmpresa = localStorage.getItem("idEmpresa"); //Extraer el id de la empresa.
        let token = localStorage.getItem('token'); //Extraer el token del localStorage.
        let headers = { //Definir el encabezado de la petición.
            Authorization: `Bearer ${token}`
        };

        //Definir el endpoint de la ruta y realizar la petición.
        let url = Global.url + `chat/${filter}/${idEmpresa}/${idLastChatPosition}` //Si existe un valor de ultima posicion de un chat, se trata de una peticion para traer mas chats en la lista de finalizados.

        if (chatEndedSearched) { //Si existe un chat finalizado buscado.
            console.log("voy a buscar un chat en específico en: CHATS FINALIZADOS", chatEndedSearched);

            let data = JSON.stringify({
                busqueda: chatEndedSearched,
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: data
            };

            responseData = await axios.request(config)
                .then((response) => {
                    console.log("hice la peticion con esta configuracion", config)
                    console.log("esta es la respuesta de la  GETCHATS FINALIZADOS con BÚSQUEDA", (response.data));
                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                })

            return responseData;
        }
        else { //Si no existe un chat finalizado buscado, se busca en los chats finalizados.
            console.log("dentro de getChatsFinish: CHATS FINALIZADOS")

            let data = JSON.stringify({
                busqueda: ""
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: url,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: data
            };

            responseData = await axios.request(config)
                .then((response) => {
                    console.log("hice la peticion con esta configuracion", config)
                    console.log("esta es la respuesta de la petición sin BÚSQUEDA", (response.data));
                    return response.data;
                })
                .catch((error) => {
                    console.log(error);
                })

            return responseData;
        }

    } catch (error) {
        console.log(error);
        throw error;
    }
};
